webpackJsonp([110631991926821],{

/***/ 1042:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"move","www_url":"http://www.deptford.tv","thema":"move","issue_month":"June","issue_year":2008,"issue_date":200806,"artist":"deptfordtv","location":"Großbritannien","email":"info@deptford.tv","id":"contribution_394","media_type":"moving_image","position_in_section":1,"media_uri":"media/2008/June/moving_image/move.mov","media_th_uri":"","still_image_count":3,"moving_image_count":1,"textz_count":9,"soundz_count":0}},"pathContext":{"id":"contribution_394"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200806-moving-image-1-243440f456f7a74ecd58.js